module.exports = __webpack_public_path__ + "img/growcify-white.d85d32d5.png";